// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__GN4eg","large":"styles_large__1JdFD"};